import { createContext } from "react";

export const PluginContext = createContext({});
